<template>
  <div class="home ">
    <!-- <video style="object-fit: cover" muted class="w100 h100 fixed" autoplay loop  
        src="../assets/videos/background.mp4"></video> -->
    <!-- <img style="object-fit: cover" class="w100 h100 absolute" src="../assets/imgs/bg.png"  /> -->
    <div class="home-container">
      <navbar></navbar>
      <div class="top-container mb w100">
        <el-row class="content" :gutter="20" :justify="isXsScreen ?'center' :'space-between'" >        
          <el-col :xs="24" :sm="24" :md="24" :lg="24">
            <div v-animate="'fadeInUp'" class="top-right radius" >
              <p class="l-mb bold" >湖南磐合科技</p>
              <p class="l-mb" >
                磐合科技有限公司是一家专注于数字化完整社区解决方案的运营服务商，致力于通过数字化手段推动基层治理现代化，构建"政府、物业、商户、居民"四端协同的数字社区生态
              </p> 
            </div>
          </el-col>
      <!--         
          <el-col :xs="24" :sm="12" :md="16" :lg="12" class="my-video"> 
            <div class="w100 h100">
             <video v-animate="'slideInDown'" style="object-fit: fill" muted class="w100 h100 " autoplay loop  
            src="../assets/videos/hmxsvideo.mp4"></video> 
            </div>
          </el-col>  -->
      </el-row>
      </div>
      <div :class="{'w80':screenSize >= 1040,'item-container':true}">
         <div class="content2 mb">
          <div class="title column  l-mb">
            <p class="title-l  min-title"  v-animate="'fadeInUp'">四端协同</p>
            <p class="title-l l-mb min-title"  v-animate="'fadeInUp'">服务体系</p>
            <div class="line"></div>
          </div>
          <el-row class="cards" justify="space-around" :gutter="20">
            <el-col  :xs="12" :sm="12" :md="12" :lg="6" class="item" v-for="(item, index) in four" :key="index">
              <el-card v-animate="'fadeInUp'" class="item-card radius" style="" shadow="always">
                <img style="object-fit: fill" class="w100 m-mb"  src="../assets/imgs/img1.png"  />
                <h3 >{{item.name}}</h3>
                <p>{{item.detail}}</p>
                <p class="m-mb detail2" >{{item.detail2}}</p>
                <p v-if="screenSize >  992" class="" style="font-size: 12px;color: #666">{{ item.content }}</p>
              </el-card>
            </el-col>
          </el-row>
         </div>
         
         <div class="success mb" v-if="screenSize <=  992">
          <div class="title column  l-mb">
            <p class="title-l l-mb" v-animate="'fadeInUp'">试点案例</p>
            <div class="line"></div>
          </div>
          <div class="success-scroll">
            <div class="success-card" v-for="(item, index) in success" :key="index">
              <el-card v-animate="'fadeInUp'" class="success-el-card radius" shadow="always">
                <img style="object-fit: fill" class="w100 m-mb"  :src="item.img"  />
                <div class="detail ">
                  <h3 class="m-mb">{{item.name}}</h3>
                  <p class="" style="font-size: 12px;color: #666">{{ item.content }}</p>
                </div>
              </el-card>
            </div>
          </div>
         </div>

        <div class="success mb" v-else>
          <div class="title column  l-mb">
            <p class="title-l l-mb" v-animate="'fadeInUp'">试点案例</p>
            <p class="title-m l-mb" v-animate="'fadeInUp'">工农桥社区</p>
            <div class="line"></div>
          </div>
          <el-carousel class="w100" v-animate="'fadeInRightBig'" :autoplay="false" :interval="4000" type="card" height="400px">
            <el-carousel-item v-for="(item, index) in success" :key="index" motion-blur>
                <div class="carousel-detail flex">
                  <img style="object-fit: fill" class="m-mb"  :src="item.img"  />
                  <div class="detail">
                    <h3 class="m-mb white">{{item.name}}</h3>
                    <p class="white" style="font-size: 15px;">{{ item.content }}</p>
                  </div>
                </div>
            </el-carousel-item>
          </el-carousel>
        </div>

        <div class="advantages mb">
          <div class="title column  l-mb">
            <p class="title-l l-mb" v-animate="'fadeInUp'">核心优势</p>
            <div class="line"></div>
          </div>
          <div class="advantage-cards">
            <div class="advantage-card" v-animate="idx<=1?'fadeInTopLeft' : 'fadeInTopRight'" v-for="(item, idx) in advantageList" :key="idx">
              <img class="advantage-icon" :src="item.icon" alt="icon" />
              <h3 class="advantage-title">{{ item.title }}</h3>
              <div class="advantage-desc">{{ item.desc }}</div>
              <div class="advantage-detail">{{ item.detail }}</div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>    
    
  </div>
</template>


<script>
import navbar from '@/components/navbar.vue';
import Footer from '@/components/Footer.vue';
import { useScreenSize } from '@/composables/useScreenSize';
const { screenWidth } = useScreenSize();
export default {
  components:{
    navbar,
    Footer
  },
  name: 'Home',
  data(){
    return{
     isMenuVisible: false, // 控制菜单的显示状态
     screenSize:1024,
     four:[
      {
        name:"政府端",
        detail:"智慧治理平台",
        detail2:"（底数清，状态明）",
        content:"实现社区消防治安养老服务，流动人口管理等社区事件的一屏指挥"
      },
      {
        name:"物业端",
        detail:"智慧物业管理",
        detail2:"（降本增效）",
        content:"创新社区物业共建共治模式，提升物 业服务满意度"
      },
      {
        name:"商户端",
        detail:"数字化供应链",
        detail2:"（安全溯源）",
        content:"创新社区物业共建共治模式，提升物 业服务满意度"
      },
      {
        name:"居民端",
        detail:"普惠生活服务",
        detail2:"（和美健康）",
        content:"数字化本地生活，社区共建共治共享"
      },
     ],
     success:[
      {
        img: require('../assets/imgs/community1.jpg'),
        name:"社区简介",
        content:"工农桥社区是数字化便民生活圈示范点，依托微信小程序打造线上服务平台，覆盖周边1.2万居民。社区以“智慧服务、邻里共享”为核心理念，整合政务咨询、物业报修、活动报名等功能，实现“指尖办事”。"
      },
      {
        img: require('../assets/imgs/community2.png'),
        name:" 核心特色",
        content:"在线提交物业维修、开具证明等需求，24小时内响应；兴趣小组、二手交易板块促进居民互动；每月组织手工课、健康讲座等线下活动，增强社区凝聚力；停水停电、政策变动等信息精准推送，避免遗漏。"
      },
      {
        img: require('../assets/imgs/community3.jpg'),
        name:"运营模式",
        content:"社区采用“网格员+志愿者+智能系统”三方协同机制：网格员负责需求审核与调度，志愿者协助活动执行，智能系统自动派单并追踪进度。每周召开线上例会优化服务，居民满意度长期保持在92%以上。"
      },
       {
        img: require('../assets/imgs/community4.jpg'),
        name:"未来计划",
        content:"2025年将重点升级三项服务：完善与数字社区平台的合作；开发老年友好模式（大字体、语音交互）；引入商户合作，提供社区团购、家政预约等增值服务，打造“15分钟便民生态圈”。"
      },
      
     ],
     advantageList:[
      {
        icon: require('../assets/imgs/advantage1.png'),
        title: '规模经营',
        desc: '规模化的运营不仅提供更多优质的选择，还保障确保服务质量，降低运营成本。',
        detail: ''
      },
      {
        icon: require('../assets/imgs/advantage2.png'),
        title: '专业化团队',
        desc: '团队深度融合区块链、数字孪生、适老化交互等前沿技术，专注打造"技术+运营+服务"一体化的基层治理数字化解决方案。',
        detail: ''
      },
      {
        icon: require('../assets/imgs/advantage3.png'),
        title: '技术研发',
        desc: '一直将技术创新视为企业的活力源泉，建立了一整套现代化服务系统。',
        detail: ''
      },
      {
        icon: require('../assets/imgs/advantage4.png'),
        title: '体系规范',
        desc: '各项服务指标均已接近国际领先水平，服务质量和客户满意度也随之大幅提升。',
        detail: ''
      }
     ]
    }
  },
  computed: {
    isXsScreen() {
      return screenWidth.value <= 768; 
    }
  },
  mounted(){
    console.log()
    this.screenSize = screenWidth.value
  },
  methods: {
   
  } 
}
</script>

<style scoped lang="scss">
.home{
  position: relative;
  z-index: 1;
  width: 100vw;
  height: 100vh;
  overflow: hidden !important; 
}
.home-container{
  width: 100%;
  margin: 0 auto;
  height: 100%;
  overflow-y: scroll; 
  overflow-x:hidden;
  
}
.top-container{
  padding: 1rem;
  background-image: url("../assets/imgs/bg.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  display: flex;
  align-items: center;
}

.top-right{
  text-align: left;
  padding: 20px;
  background-color: rgb(250 250 250 / 70%);
}

.content2{

}


.advantage-cards {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 32px;
  margin: 40px 0 0 0;
}
.advantage-card {
  background: #fff;
  border-radius: .8rem;
  padding: 40px 24px 32px 24px;
  flex: 1;
  min-width: 220px;
  max-width: 300px;
  box-sizing: border-box;
  transition: box-shadow 0.3s;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.advantage-card:hover {
  box-shadow: 0 8px 32px 0 rgba(0,0,0,0.12);
}
.advantage-icon {
  width: 56px;
  height: 56px;
  margin-bottom: 24px;
}
.advantage-title {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 16px;
}
.advantage-desc {
  font-size: 16px;
  color: #666;
  margin-bottom: 8px;
}
.advantage-detail {
  font-size: 14px;
  color: #999;
}
.title{
      display: flex;
      align-items: center;
      justify-content: center;
      .line{
        width: 100px;
        height: 2px;
        background-color: #0059FA;
      }
    }



/* 小屏幕 (手机) */
@media (max-width: 768px) {
   .home-container{
     width: 100%;
  }
  
 .top-container{
  width: 100%;

  margin-top: 4rem;
  height: 20rem;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  .content{
    width: 100%;
    .top-right{
      padding: 20px 50px;
      p:nth-child(1){
        font-size: 1.1rem;
        }
      p:nth-child(2){
        font-size: .9rem;
    }

    }

   
    
  }
  p{
    text-align: center;
  }
  .my-video{
    margin-top:3rem
  }
  
}
  .top-right{
    text-align: left;
  }

  .title{
    p{
    font-size: 2rem !important;
    }
  }

  .detail2{
        font-size: .8rem !important;
      }
  .min-title{
    font-size: 40px !important;
  }
  .item-container{
    width: 100%;
    padding: 0 1rem;
  }
  .content2{
    display: flex;
    align-items: stretch;
    flex-direction: column;
    justify-content: space-around;
    width: 100%;
    .cards{
      
      .item{
        margin-bottom: 2rem;
        .item-card{
          height: 17rem;
        }
       
      }
    }
  }

  .success{
    .title{
      align-items: flex-start;
    }
  }

  .success-scroll {
    display: flex;
    flex-direction: column;
    overflow-x: auto;
    gap: 1rem;
    padding-bottom: 1rem;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    align-items: center;
  }
  .success-scroll::-webkit-scrollbar {
    display: none;
  }
  .success-card {
    flex: 0 0 80vw;
    max-width: 80vw;
    min-width: 220px;
    box-sizing: border-box;
  }
  .success-el-card {
    width: 100%;
    min-width: 220px;
    max-width: 80vw;
    margin: 0 auto;
  }
  .advantage-cards {
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }
  .advantage-card {
    max-width: 100%;
    width: 100%;
    padding: 24px 12px 20px 12px;
  }

}

/* 中等屏幕 (平板) */
@media (min-width: 768px) and (max-width: 1026px) {
  .home-container{
     width: 100%;
  }
  .top-container{
    height: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    .content{
        width: 80%;
        margin: 0 auto;
        p:nth-child(1){
          font-size: 3rem;
        }
        p:nth-child(2){
          font-size: 2rem;
        }
    }
  }

  .item-container{
    width: 80%;
    padding: 0 1rem;
    margin: 0 auto;
  }
 .top-container{
    margin-bottom: 5rem;

  }
  .top-right{
    text-align: left;
  }
  .content2{
    display: flex;
    align-items: stretch;
    flex-direction: column;
    justify-content: space-around;
    width: 100%;
  }

  
  .content2{
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    .item{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: center;
      margin-bottom: 30px;
    }
    .item-card{
        width: 80%;
        min-height: 370px !important;
      }
    img{
      width: 200px;
      height: 200px;
      
    }
  }

  .success{
    
    .detail{
      padding: 0 20px 0 20px;
      text-align: left;
    }

    ::v-deep .el-card__body{
      padding: 0 !important;
    }

    .el-carousel__item h3 {
      line-height: 20px;
      margin: 0;
      text-align: center;
    }

    .el-carousel__item:nth-child(2n) {
      background-color: #0059FA;
    }

    .el-carousel__item:nth-child(2n + 1) {
      background-color: #0059FA;
    }

    ::v-deep .el-carousel__mask{
      opacity: 0.55 !important;
    }

    .carousel-detail{
          height: 100%;
          flex-direction: column;
        img{
          width: 100%;
          height: 50%;
        }
    }
  
  }
  .advantage-cards {
    gap: 16px;
    min-width: 185px;
  }
  
  .footer-content {
    padding: 0 16px;
  }
}

/* 大屏幕 (电脑) */
@media (min-width: 1026px) {

  .home-container{
  }

  .top-container{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .content{
        width: 1140px;
        margin: 0 auto;
        p:nth-child(1){
          font-size: 3rem;
        }
        p:nth-child(2){
          font-size: 2rem;
        }
    }
  }

  .top-right{
    text-align: left;
    padding: 90px;
  }



  .content2{
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    .item-card{
        min-height: 370px !important;
      }
    img{
      height: 200px;
      
    }
  }

  .success{
    
    .detail{
      padding: 0 20px 0 20px;
      text-align: left;
    }

    ::v-deep .el-card__body{
      padding: 0 !important;
    }

    .el-carousel__item h3 {
      line-height: 100px;
      margin: 0;
      text-align: center;
    }

    .el-carousel__item:nth-child(2n) {
      background-color: #0059FA;
    }

    .el-carousel__item:nth-child(2n + 1) {
      background-color: #0059FA;
    }

    ::v-deep .el-carousel__mask{
      opacity: 0.55 !important;
    }

    .carousel-detail{
          height: 100%;
        img{
          width: 60%;
          height: 100%;
        }
    }
  
  }
  .advantage-cards {
    gap: 32px;
  }
  .footer-content {
    padding: 0 32px;
  }

}

</style>
